import { Ethnicity } from '@/models';
import { GenericService } from './generic.service';

export class EthnicityService extends GenericService<Ethnicity> {
  endpoint = 'v1/ethnicities';
}
